import React from 'react';
import {Container , Grid } from '@material-ui/core';
import FooterAbout from './footer-about';
import FooterQL from './quickLinks';
import FooterAl from './additionalLink';
// import FooterLink from './linksToDistrictOffice';
import FooterSocial from './social';
import Branch from '../../../../models/branch.model';

interface Props{
  branch?:Branch|undefined
}
const FooterMain:React.FC<Props> = ({branch} ) =>{
  return(
    <div className="section-break-4 ecn-footer-main bg-primary-regular">
      <Container maxWidth="lg">

        <Grid container spacing={2} className="align-item-center">

          <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
            {/* {// Footer about} */}
            <FooterAbout branch={branch}/>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={9} xl={9}>
            <Grid container spacing={4}>
            
              <Grid item xs={12} md={6} lg={4} xl={4}>
                {/* {// quick link} */}
               <FooterQL/> 
              </Grid>

              {/* <Grid item xs={12} md={6} lg={3} xl={3}>
                <FooterLink/>
              </Grid>  */}

              <Grid item xs={12} md={6} lg={4} xl={4}>
                {/* {// additional link} */}
                <FooterAl/>
              </Grid>

              <Grid item xs={12} md={6} lg={4} xl={4}>
                {/* {// footer social} */}
                <FooterSocial/>
              </Grid>
              
            </Grid>
          </Grid>

        </Grid>
        
      </Container>
    </div>
  );
}

export default FooterMain;